export const COMPANY = 'COMPANY';
export const PARTNER = 'PARTNER';
export const WHOLESALER = 'WHOLESALER';
